'use strict';

/**
 * @classname SetBlankShop
 * @classdesc 空店舗設定
 */
export default class SetBlankShop {
	/**
	 * @constructor
	 * @param {jQuery} $e - body
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		// ログインしている場合はチェックしない
		if($('.header').hasClass('header--logined')) return;
		// お気に入り店舗登録ページならチェックしない
		if($('body').hasClass('page-select-favorite-shop')) return;
		// プレビューページならチェックしない
		if($('body').hasClass('page-preview')) return;
		const SetBlankShoped = window.localStorage.getItem('_cfs_') || null;
		if(!SetBlankShoped) {
			window.localStorage.setItem('_cfs_', '{}');
		}
	};
};
